import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { UiButtonComponent } from '../ui-button/ui-button.component';
import { provideNativeDateAdapter } from '@angular/material/core';

export interface Comment {
  replyId: string;
  name: string;
  text: string;
}

@Component({
  selector: 'ui-comment-form',
  templateUrl: './ui-comment-form.component.html',
  styleUrls: ['./ui-comment-form.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, UiButtonComponent],
  providers: [provideNativeDateAdapter()],
})
export class UiCommentFormComponent implements OnChanges {
  @Input()
  public replyId = '';

  @Output()
  public saved = new EventEmitter<Comment>();
  @Output()
  public canceled = new EventEmitter<void>();

  public commentForm;

  constructor(private fb: FormBuilder) {
    this.commentForm = this.fb.group({
      replyId: [''],
      name: ['', (control: AbstractControl) => Validators.required(control)],
      text: ['', (control: AbstractControl) => Validators.required(control)],
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['replyId']) {
      this.commentForm.patchValue({ replyId: this.replyId });
    }
  }

  public save(): void {
    this.commentForm.markAllAsTouched();
    if (this.commentForm.valid) {
      this.saved.emit(this.commentForm.getRawValue() as Comment);
      this.commentForm.reset({ replyId: this.replyId, name: '', text: '' });
    }
  }

  public cancel(): void {
    this.canceled.emit();
  }
}
